import { render, staticRenderFns } from "./handleSelectItem.vue?vue&type=template&id=5166b26a"
import script from "./handleSelectItem.vue?vue&type=script&lang=js"
export * from "./handleSelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports